let lastId = 0;
export default function generateId(prefix='id') {
    lastId++;
    return `${prefix}${lastId}`;
}
